import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_CHECK: GlameraIconDefinition = {
  name: 'user-check',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-user-check-tick" d="m16 11 2 2 4-4"></path>
    <path class="glm-user-check-body" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle class="glm-user-check-head" cx="9" cy="7" r="4"></circle>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
